import type { SystemStyleObject } from "@chakra-ui/theme-tools";

const linkStyle: SystemStyleObject = {
    textDecoration: "none",
    position: "relative",
    _hover: {
        textDecoration: "none",
    },
    w: "inherit",
};

const imageContainer: SystemStyleObject = {
    aspectRatio: "4/5",
    width: "100px",
    maxWidth: "100%",
};

const imageStyle: SystemStyleObject = {
    display: "inline-flex",
    aspectRatio: "4/5",
    width: "100px",
    maxWidth: "100%",
};

const headlineStyle: SystemStyleObject = {
    fontWeight: "semibold",
};

const priceBoxStyle: SystemStyleObject = {
    textAlign: "right",
};

const priceNowStyle: SystemStyleObject = {
    fontWeight: "semibold",
    color: "black",
    mr: 2.5,
};

const priceBeforeStyle: SystemStyleObject = {
    color: "gray.600",
    fontWeight: "semibold",
    textDecoration: "line-through",
};

const descriptionStyle: SystemStyleObject = {
    fontWeight: "semibold",
};

const metaStyle: SystemStyleObject = {
    color: "gray.500",
    fontSize: ["mobileBodyB3", "mobileBodyB3", "desktopBodyB4", "desktopBodyB4"],
};

const metaContainer: SystemStyleObject = {
    lineHeight: 1,
    color: "gray.500",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
};

const row: SystemStyleObject = {
    display: "flex",
    justifyContent: "start",
    gap: 15,
    background: "white",
    p: 2,
};

export const productRowStyles = {
    root: row,
    link: linkStyle,
    imageContainer,
    image: imageStyle,
    headline: headlineStyle,
    description: descriptionStyle,
    metaStyle,
    metaContainer,
    price: priceBoxStyle,
    priceNow: priceNowStyle,
    priceBefore: priceBeforeStyle,
};
